import { Link } from "react-router";
import { my_routes } from "../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FinanceMenu from "./financeMenu";
import "./finance.css";

const FinanceHome = () => {
  const routes = my_routes;

  const quickActions = [
    {
      title: "Consulter les paiements",
      text: "Retrouvez rapidement les étudiants, les montants dus et les paiements reçus.",
      icon: "ti ti-receipt-2",
      route: routes.allPayment,
      button: "Ouvrir",
    },
    {
      title: "Gérer les échéanciers",
      text: "Créez ou ajustez les plans de paiement de l'année académique.",
      icon: "ti ti-wallet",
      route: routes.PaymentPlan,
      button: "Voir les plans",
    },
    {
      title: "Bourses et remises",
      text: "Suivez les réductions accordées et leur impact sur les frais.",
      icon: "ti ti-users-group",
      route: routes.bourseAndRemise,
      button: "Analyser",
    },
  ];

  const checkpoints = [
    "Paramètres de devise et comptes bancaires configurés",
    "Plans de paiement rattachés aux étudiants concernés",
    "Reçus et rapports financiers prêts à être édités",
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <FinanceMenu />
          {/* Page Header */}
          {/* <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                  <div className="my-auto mb-2">


                    <h3 className="page-title mb-1">Gestion des Finances</h3>
                    <nav>
                      <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                          <Link to={routes.financeHome}>Accueil</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                          Paiements
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div> */}
          {/* /Page Header */}

          <section className="finance-home-hero">
            <div className="finance-home-hero-content">
              <span className="finance-home-kicker">Paiements</span>
              <h2>Pilotez les paiements avec plus de clarté</h2>
              <p>
                Un point d'entrée vivant pour suivre les frais, préparer les
                encaissements, garder les échéances visibles et accéder aux
                actions importantes sans détour.
              </p>
              <div className="finance-home-actions">
                <Link to={routes.allPayment} className="btn btn-primary">
                  <i className="ti ti-cash me-2" />
                  Voir les paiements
                </Link>
                <Link to={routes.PaymentPlan} className="btn btn-light">
                  <i className="ti ti-calendar-stats me-2" />
                  Échéanciers
                </Link>
              </div>
            </div>
            <div className="finance-home-hero-panel">
              <div className="finance-home-card-chip">
                <i className="ti ti-shield-check" />
                Opérations suivies
              </div>
              <div className="finance-home-card-amount">Paiements</div>
              <div className="finance-home-card-line">
                <span>Plans</span>
                <strong>Actifs</strong>
              </div>
              <div className="finance-home-card-line">
                <span>Reçus</span>
                <strong>Disponibles</strong>
              </div>
              <div className="finance-home-card-progress">
                <span />
              </div>
            </div>
          </section>

          {/* <div className="row g-3 mb-4">
                  {financeStats.map((stat) => (
                    <div className="col-xl-4 col-md-6" key={stat.label}>
                      <div className={`finance-stat-card ${stat.className}`}>
                        <div className="finance-stat-icon">
                          <i className={stat.icon} />
                        </div>
                        <div>
                          <span>{stat.label}</span>
                          <h5>{stat.value}</h5>
                          <p>{stat.text}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div> */}

          <div className="row g-3">
            <div className="col-xl-8">
              <div className="finance-section-panel">
                <div className="finance-section-header">
                  <div>
                    <span className="finance-home-kicker">Actions rapides</span>
                    <h4>Reprendre le travail financier</h4>
                  </div>
                </div>
                <div className="row g-3">
                  {quickActions.map((action) => (
                    <div className="col-lg-4 col-md-6" key={action.title}>
                      <Link to={action.route} className="finance-action-card">
                        <i className={action.icon} />
                        <h6>{action.title}</h6>
                        <p>{action.text}</p>
                        <span>
                          {action.button}
                          <i className="ti ti-arrow-right" />
                        </span>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-xl-4">
              <div className="finance-section-panel finance-check-panel">
                <span className="finance-home-kicker">À vérifier</span>
                <h4>Avant d'encaisser</h4>
                <div className="finance-check-list">
                  {checkpoints.map((item) => (
                    <div className="finance-check-item" key={item}>
                      <i className="ti ti-circle-check" />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
                <div className="finance-alert-note">
                  <i className="ti ti-info-circle" />
                  <span>
                    Les données détaillées restent disponibles dans les pages
                    Paiements, Échéanciers et Bourses & Remises.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinanceHome;
